// extracted by mini-css-extract-plugin
module.exports = {"item":"ListComponentItemCircle_item__PxsZS","image":"ListComponentItemCircle_image__EnAiu"};